import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import Header from './Header';
import SupportChat from './SupportChat';
import InstallAppPrompt from './InstallAppPrompt';

export default function Layout({ children }) {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const isAdminShell = user?.role === 'admin' || user?.role === 'escrow';
  const hideShell = isAdminShell || location.pathname.startsWith('/messages') ||
    location.pathname.startsWith('/support') ||
    ['/login', '/register', '/reset-password'].includes(location.pathname);

  const shellClasses = [
    'app-shell',
    hideShell ? 'no-shell' : '',
    isAdminShell ? 'admin-layout-host' : ''
  ].filter(Boolean).join(' ');

  return (
    <div className={shellClasses}>
      {!hideShell && <Header />}
      <div className={hideShell ? `main-area no-shell ${isAdminShell ? 'admin-layout-area' : ''}`.trim() : 'customer-content-area'}>
        <main className={hideShell
          ? `main-content no-shell ${isAdminShell ? 'admin-layout-content' : ''}`.trim()
          : 'app-content'}
        >
          {children}
        </main>
      </div>
      {!hideShell && (
        <footer className="site-footer">
          <p>© {new Date().getFullYear()} GetSocs. Verified community &amp; social asset escrow.</p>
          <div className="footer-right">
            <Link to="/policy">Terms &amp; Privacy</Link>
            <Link to="/support">Help Center</Link>
          </div>
        </footer>
      )}
      {!isAdminShell && <InstallAppPrompt />}
      {!isAdminShell && <SupportChat />}
    </div>
  );
}
